import type { TScreenOrientation } from '@/services/ScreenService'

/** QR card padding for the pairing / registration idle screen. */
export const REGISTRATION_QR_CARD_PADDING = 'clamp(0.4rem, 0.9vmin, 1.25rem)'

/**
 * Pairing QR sizing: portrait uses vmin for distance legibility; landscape caps by vh so logo + code fit.
 */
export function registrationQrBoxStyle(orientation: TScreenOrientation) {
  if (orientation === 'horizontal') {
    return {
      width: 'min(22vh, 36vw, 13rem)',
      aspectRatio: '1',
      maxHeight: '22vh'
    } as const
  }
  return {
    width: 'min(40vmin, 18rem)',
    aspectRatio: '1',
    maxHeight: '40vmin'
  } as const
}

export function registrationCodeTextStyle(orientation: TScreenOrientation) {
  return {
    fontSize: orientation === 'horizontal'
      ? 'clamp(2rem, 5vh, 4.5rem)'
      : 'clamp(2.25rem, 7vmin, 5.5rem)',
    textShadow: '0 0 40px rgba(6,182,212,0.35), 0 0 80px rgba(6,182,212,0.15)'
  } as const
}

export function registrationInstructionTextStyle(orientation: TScreenOrientation) {
  return {
    fontSize: orientation === 'horizontal'
      ? 'clamp(0.85rem, 1.6vh, 1.35rem)'
      : 'clamp(0.9rem, 1.85vmin, 1.65rem)'
  } as const
}

/** Registration idle logo — vertical mounts need a larger lockup vs QR/code. */
export function registrationLogoWrapStyle(orientation: TScreenOrientation) {
  if (orientation === 'horizontal') {
    return undefined
  }
  return {
    maxWidth: 'min(88vw, 68vmin)',
    maxHeight: 'min(24vmin, 80vw)'
  } as const
}
